import { Component, OnInit } from '@angular/core';
import { Observable, tap } from 'rxjs';

import { PageNames } from 'src/app/configs/page-names.enum';
import { ExcelTypes } from 'src/app/core/api/models';
import { BaseOutboxMessagesComponent } from '../base-outbox-messages/base-outbox-messages.component';

@Component({
  selector: 'app-current-user-outbox-messages',
  templateUrl: '../base-outbox-messages/base-outbox-messages.component.html',
  standalone: false,
})
export class CurrentUserOutboxMessagesComponent
  extends BaseOutboxMessagesComponent
  implements OnInit
{
  //#region Properties
  getTotalCountApiMethodName: string =
    this.currentService
      .outBoxMessagesGetCurrentUserOutBoxMessagesTotalReceiversCountTotalPrices
      .name;
  pageTitle: string = 'pages.outboxMessages.userTitle';
  excelType = ExcelTypes.UserOutboxMessages;
  tabName = PageNames.currentUserOutboxMessages;
  //#endregion

  getPaginationApi(): Observable<any> {
    this.setSelectedFields();
    const body = this.getPaginationBody();

    return this.outBoxMessagesGQLService
      .getCurrentUserOutBoxMessagesWithPagination(
        {
          ...body,
        },
        this.selectedFields
      )
      .pipe(
        this.graphQlPipeOperators(),
        tap((res: any) => {
          this.isAdvancedSearch = false;
          this.calcTotalSumCurrentPage(res?.data?.items);
        })
      );
  }

  setSelectedFields() {
    super.setSelectedFields();
    this.selectedFields = this.selectedFields.filter(
      (sf) => ![this.columnNames.createdBy].includes(sf)
    );
  }
}
